// extracted by mini-css-extract-plugin
export default {"redirect":"redirect-module--redirect--38327"};